export default Object.freeze({
  ProcessInstance: 1,
  User: 2,
});
